import { GlobalHealthSystem } from "../healthSystem/global-health-system";
import { Practitioner } from "../practitioner/practitioner";
import { StaffDetails } from "./staffDetails";


export class HealthOrganizationSetup {
  practices: GlobalHealthSystem[] = [];
  physicians: Practitioner[] = [];
  midLevels: Practitioner[] = [];
  staff: StaffDetails[] = [];
}
